import { LineBatchMeta } from '@shared/components/ui/LineBatchMeta';
import type { BatchSummary } from '@shared/models/BatchSummary';
import React from 'react';
import type { RelocationLine } from '../../models';

/** Lote de la línea — mismo componente que ubicaciones / órdenes (`LineBatchMeta`). */
export const RelocationMovedLineLot: React.FC<{ line: RelocationLine }> = ({ line }) => {
  const batchId = line.batch_id ?? line.batch?.id ?? undefined;

  const hasAnyBatch = batchId != null || Boolean(line.batch?.batch_number?.trim()) || Boolean(line.batch?.expiry_date);

  if (!hasAnyBatch) {
    return null;
  }

  const summary: BatchSummary | undefined =
    line.batch != null || batchId != null
      ? {
          id: line.batch?.id ?? batchId ?? 0,
          batch_number: line.batch?.batch_number ?? undefined,
          expiry_date: line.batch?.expiry_date ?? undefined,
        }
      : undefined;

  return (
    <div className="mt-2">
      <LineBatchMeta
        batch={summary}
        batchId={batchId ?? null}
        hideNumericIdFallback
        i18nNs="relocationProcessModule"
        lotLabelKey="panel.batch"
        expiryLabelKey="panel.expiry"
      />
    </div>
  );
};
